/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-08-25 10:46:28
 *
 *******************************************************/

import RankingBanner from 'src/assets/images/advance-search/ranking-banner.png';
import AiSynonymBanner from 'src/assets/images/advance-search/ai-synonyms-banner.png';
import ScopedSuggestionBanner from 'src/assets/images/advance-search/scoped-suggestion-banner.png';
import SemanticBanner from 'src/assets/images/advance-search/semantic-banner.png';

export const StandardSearchTab = {
  relevanceSettings: 'relevance-settings',
  instantSearchWidget: 'instant-search-widget',
  searchResultsPage: 'search-results-page',
  inCollection: 'in-collection',
  manualSynonyms: 'manual-synonyms',
  newManualSynonyms: 'new-manual-synonyms',
  editManualSynonyms: 'edit-manual-synonyms',
  stopWords: 'stop-words',
  redirects: 'redirects',
  newRedirects: 'new-redirects',
  editRedirects: 'edit-redirects',
  suggestionDictionary: 'suggestion-dictionary',
  newSuggestionDictionary: 'new-suggestion-dictionary',
  editSuggestionDictionary: 'edit-suggestion-dictionary'
};

export const AdvanceSearchTab = {
  aiSynonyms: 'ai-synonyms',
  semanticSearch: 'semantic-search',
  productPerformanceRanking: 'product-performance-ranking',
  searchPersonalization: 'search-personalization'
};

export const AdvanceSearchFeaturePreview = [
  {
    name: 'ranking',
    image: RankingBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.ranking_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.ranking_content'
  },
  {
    name: 'semantic',
    image: SemanticBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.semantic_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.semantic_content'
  },
  {
    name: 'aiSynonyms',
    image: AiSynonymBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.aiSynonyms_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.aiSynonyms_content'
  },
  {
    name: 'scopedSuggestion',
    image: ScopedSuggestionBanner,
    title: 'AdminHTML.AdvanceSearch.PremiumFeature02.scopeSuggestion_title',
    content: 'AdminHTML.AdvanceSearch.PremiumFeature02.scopeSuggestion_content'
  }
];
export const MAXIMUM_RE_RANK_ITEMS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export const ENABLE_SEARCH_PERSONALIZATION_STORES = [
  '17a175-4.myshopify.com',
  '4cde93-3.myshopify.com',
  'a708f9-2.myshopify.com',
  'abbyson1.myshopify.com',
  'adasa-2.myshopify.com',
  'american-hospital-supply.myshopify.com',
  'amscope-us-dev.myshopify.com',
  'apl-athletic-propulsion-labs.myshopify.com',
  'bcb693-3.myshopify.com',
  'bolighusetwerenberg.myshopify.com',
  'bonjourben.myshopify.com',
  'coldest-6011.myshopify.com',
  'designeroptics-com.myshopify.com',
  'duskretailus.myshopify.com',
  'dylans-candy-bar-dev.myshopify.com',
  'e03692.myshopify.com',
  'ettika-2.myshopify.com',
  'f248cd.myshopify.com',
  'f8b56c.myshopify.com',
  'fdab49-2.myshopify.com',
  'ffo1.myshopify.com',
  'finlaysonfi.myshopify.com',
  'fryguypins.myshopify.com',
  'georgerichards-storefront.myshopify.com',
  'gorjana.myshopify.com',
  'handt-prod.myshopify.com',
  'howler-brothers.myshopify.com',
  'i-miller-microscopes.myshopify.com',
  'ivalo-com.myshopify.com',
  'jeffreycampbell.myshopify.com',
  'jocko-fuel-wholesale.myshopify.com',
  'jocko-fuel.myshopify.com',
  'kah-online.myshopify.com',
  'kahala-com.myshopify.com',
  'lesports.myshopify.com',
  'm-gebauer.myshopify.com',
  'mamasuncut-store.myshopify.com',
  'motelrocks-com-aus.myshopify.com',
  'motelrocks-com-eur.myshopify.com',
  'motelrocks-com-us.myshopify.com',
  'motelrocks-com.myshopify.com',
  'mrbigandtall-storefront.myshopify.com',
  'nanouniverse.myshopify.com',
  'nuestrosecreto.myshopify.com',
  'oberson-dev.myshopify.com',
  'palmaira-sandals-australia.myshopify.com',
  'petit-seal.myshopify.com',
  'privatewhitevc.myshopify.com',
  'retail-boyz-shop.myshopify.com',
  'root-and-blow.myshopify.com',
  'shopkerrits.myshopify.com',
  'spinriteonline.myshopify.com',
  'stoned-crystals.myshopify.com',
  'superkingshop.myshopify.com',
  'svsound-2.myshopify.com',
  'therxstore.myshopify.com',
  'tiptop-storefront.myshopify.com',
  'top3au.myshopify.com',
  'toririchard-com.myshopify.com',
  'vitaminaswim-new.myshopify.com',
  'wantable-admin.myshopify.com',
  'wellforces.myshopify.com',
  'whiteriver-mouldings.myshopify.com',
  'whiteriver.myshopify.com',
  'bc-dev-v2-daisy01.myshopify.com'
];
